import User from '@/models/User'
import userService from '@/services/user.service'
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
const basePath = process.env.VUE_APP_BASE_URL;

const state = {
    user: {
        id: 0,
        login: "",
        name: "",
        type: "unauthorized",
        roles: [],
        permissions: [],
        token: null
    },
    isLoading: false
}

const getters = {
    isAuth: state => {
        return state.user.id > 0;
    }  
}

const mutations = {
    setUser (state, userInfo = null) 
    {
        console.log(userInfo);
        state.user = new User(userInfo);
    },
    setLoading(state, loading) {
        state.isLoading = loading;
    }
}

const actions = {
    login ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            userService.login(payload.credentials).then(response => {
                const user = {
                    login: response.login,
                    id: response.id,
                    name: response.name,
                    type: response.type,
                }
                commit('setUser', user);
                cookies.set("user", user, '120min', basePath);
                resolve(user);
                payload.router.go(0);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    
    logout ({ commit }, router) {
        const user = {
            id: 0,
            name: "",
            type: "unauthorized",
            roles: [],
            permissions: [],
            token: null
        };
        userService.logout().then(() => {
            commit('setUser', new User(user))
            cookies.remove('user', basePath);
            router.push({name:'home'})
        }).catch(() => {
            commit('setUser', user);
            cookies.remove('user', basePath);
            router.push({name:'home'})
        })
    },
    
    checkUserBySession({ commit }) {
        userService.getUserBySession().then(response => {
            const user = {
                id: response.id,
                login: response.login,
                name: response.name,
                type: response.type,
            }
            commit('setUser', user)
        }).catch(() => {
            cookies.remove('user', basePath);
        })
    },

    checkUserByToken({ commit }, payload) {
        userService.getUserByToken(payload.token).then(response => {
            const user = {
                id: response.id,
                login: response.login,
                name: response.name,
                type: response.type,
            }
            commit('setUser', user)
        })
    },

    getUserBySession({ commit }, router) {
        userService.getUserBySession().then(response => {
            const user = {
                id: response.id,
                login: response.login,
                name: response.name,
                type: response.type,
            }
            commit('setUser', user)
        }).catch(() => {
            router.push({name:'home'})
        })
    },

    getUserByToken({ commit }, payload) {
        userService.getUserByToken(payload.token).then(response => {
            const user = {
                id: response.id,
                login: response.login,
                name: response.name,
                type: response.type,
            }
            commit('setUser', user)
        }).catch(() => {
            payload.router.push({name:'home'})
        })
    },

    register({ commit }, formData) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            userService.register(formData).then((response) => {
                commit('setLoading', false);
                resolve(response.data);
            }).catch((error) => {
                commit('setLoading', false);
                reject(error);
            });
        });
    },

    restorePassword({ commit }, email) {
        commit('setLoading', true);
        userService.restorePassword(email).then(() => {
            commit('setLoading', false);
        }).catch(() => {
            commit('setLoading', false);
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
